
export default function Privacy() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-4xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <img 
              src="https://static.readdy.ai/image/6b096200d48de7cb5be3c2123a55bd60/02fcb7bd67b34850874869ad200c7629.png" 
              alt="코이링크 | AiLink" 
              className="h-12 w-auto object-contain"
            />
            <button 
              onClick={() => window.history.back()}
              className="flex items-center text-blue-600 hover:text-blue-700 font-medium"
            >
              <i className="ri-arrow-left-line mr-2"></i>
              돌아가기
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white">
          <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            개인정보처리방침 (개인정보 보호정책)
          </h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 leading-relaxed mb-8">
              株式会社 KABUTO(이하 "회사")는 「개인정보 보호법」 등 관련 법령을 준수하며 이용자의 개인정보를 안전하게 보호하기 위해 다음과 같이 개인정보처리방침을 수립/공개합니다. 본 방침은 회사가 제공하는 무료 상담 및 공식 LINE, Instagram 안내 서비스에 적용됩니다.
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. 수집하는 개인정보 항목</h2>
              <p className="text-gray-700 mb-4">회사는 다음과 같은 개인정보를 수집합니다.</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li><strong>이용자가 직접 입력하는 정보:</strong> 이름, 전화번호, 이메일 주소, LINE ID</li>
                <li><strong>자동으로 수집되는 정보:</strong> 쿠키, 접속 로그, 광고 측정 도구를 통한 정보</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. 개인정보의 수집 및 이용 목적</h2>
              <p className="text-gray-700 mb-4">수집된 개인정보는 다음의 목적을 위해 이용됩니다.</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>무료 상담의 안내 및 진행</li>
                <li>공식 LINE 채널 및 공식 Instagram 등록 안내</li>
                <li>서비스 및 이벤트 정보 제공</li>
                <li>광고 효과 측정 및 분석</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. 개인정보의 보유 및 이용 기간</h2>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>개인정보는 수집/이용 목적 달성 후 지체 없이 파기합니다.</li>
                <li>단, 관련 법령 및 내부 방침에 따라 최대 5년간 보관할 수 있습니다.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. 개인정보의 제3자 제공</h2>
              <p className="text-gray-700">
                회사는 원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. 개인정보 처리의 위탁</h2>
              <p className="text-gray-700">
                회사는 이용자의 개인정보를 외부 업체에 위탁하지 않습니다.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. 이용자의 권리</h2>
              <p className="text-gray-700 mb-4">
                이용자는 언제든지 회사에 대해 본인의 개인정보에 대한
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4">
                <li>열람</li>
                <li>정정</li>
                <li>삭제</li>
                <li>처리 정지</li>
              </ul>
              <p className="text-gray-700">
                를 요청할 수 있습니다.
              </p>
              <p className="text-gray-700 mt-4">
                요청은 이메일 또는 전화로 접수 가능하며 회사는 법령에서 정한 기한 내에 조치를 취합니다.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. 개인정보 보호 책임자</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <ul className="space-y-2 text-gray-700">
                  <li><strong>책임자 직위:</strong> 대표이사 사장</li>
                  <li><strong>성명:</strong> akihiro nakayama</li>
                  <li><strong>연락처:</strong> kabuto.co.ltd@gmail.com / 09082986698</li>
                </ul>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">8. 부칙</h2>
              <p className="text-gray-700">
                본 개인정보처리방침은 2025년 10월 1일부터 시행됩니다.
              </p>
            </section>
          </div>

          {/* Contact Section */}
          <div className="mt-12 p-6 bg-blue-50 rounded-lg">
            <h3 className="text-xl font-bold text-gray-900 mb-4">문의사항</h3>
            <p className="text-gray-700 mb-4">
              개인정보 처리에 관한 문의사항이 있으시면 언제든지 연락해 주세요.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <div className="flex items-center">
                <i className="ri-mail-line text-blue-600 mr-3"></i>
                <span className="text-gray-700">kabuto.co.ltd@gmail.com</span>
              </div>
              <div className="flex items-center">
                <i className="ri-phone-line text-blue-600 mr-3"></i>
                <span className="text-gray-700">09082986698</span>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 mt-16">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <p className="text-gray-400">
            © 2024 일한연애 동반케어. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
